import { Box, Button, IconButton, Switch } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { rem, noSplit, getCardName, cardImg } from "assets/js/common";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import JsBarcode from "jsbarcode";
import { makeStyles } from "@mui/styles";
import Sheet from "react-modal-sheet";
import { useHistory } from "react-router";
import axios from "axios";
import { Cookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import ReactBarcode from "react-jsbarcode";
import { setBottomColor } from "assets/js/apphandle";
import moment from "moment";
import RefreshIcon from "@mui/icons-material/Refresh";

const useStyles = makeStyles((theme) => ({
  appCard: {
    "& .react-modal-sheet-container": {
      transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
    },
    "& .react-modal-sheet-header": {
      background: "transparent",
      zIndex: 9999,
      "&:before": {
        content: "''",
        width: rem(50),
        height: rem(5),
        borderRadius: rem(3),
        background: "#fff",
        position: "absolute",
        bottom: rem(9),
      },
      "& .react-modal-sheet-drag-indicator": {
        display: "none",
      },
    },
    "& .react-modal-sheet-content": {
      boxShadow: "rgb(0 0 0 / 30%) 0px -2px 16px",
      background: "#fff",
      borderTopLeftRadius: rem(30),
      borderTopRightRadius: rem(30),
      display: "flex",
      flexDirection: "column",
    },
    "& .react-modal-sheet-backdrop": {
      border: "none",
    },
    "& .barcode": {
      position: "relative",
      "& .cover": {
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        width: "100%",
        height: "100%",
        // backgroundColor: `rgba(255,255,255,0.7)`,
        zIndex: 1,
        paddingBottom: rem(15),
        "&:before": {
          content: "''",
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          backgroundImage:
            "linear-gradient(to bottom, rgba(255,255,255,.95) 0%, rgba(255,255,255,.95) 80%, rgba(255,255,255,.8) 81%, rgba(255,255,255,.8) 100%)",
          // background: theme.palette.common.white,
          // opacity: 0.8,
        },
        "& .MuiButton-root": {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          color: theme.palette.primary.main,
          fontWeight: 700,
          zIndex: 5,
          fontSize: rem(13),
          "& .MuiSvgIcon-root": {
            width: rem(30),
            height: rem(30),
            color: theme.palette.primary.main,
          },
        },
      },
    },
  },
}));

const cookies = new Cookies();

export default function AppCardDrawer(props) {
  const classes = useStyles();
  const history = useHistory();

  const no = cookies.get("no");

  const { open, handleDrawerClose, text, subText, btmText, callback } = props;

  const [value, setValue] = useState(0);
  const [myDecodedToken, setMyDecodedToken] = useState("");
  const [point, setPoint] = useState("");
  const [easyCard, setEasyCard] = useState("");
  const [epYn, setEpYn] = useState(false);
  const [barcodeNo, setBarcodeNo] = useState("99" + cookies.get("no"));
  const [timeLimit, setTimeLimit] = useState(false);
  const [timer, setTimer] = useState("");

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const loadCardList = async () => {
    await axios
      .get(`/api/app/easy-card/my`)
      .then((res) => {
        setEpYn(res.data.data.epYn);
        if (res.data.data.easyCardList) {
          console.log(
            "res.data.data.easyCardList: ",
            res.data.data.easyCardList
          );

          let eCard = _.find(res.data.data.easyCardList, (item) => {
            return item.repYn === "Y";
          });
          console.log("eCard: ", eCard);
          setEasyCard(eCard);
        }
      })
      .catch((error) => {});
  };

  const loadMyInfo = async () => {
    await axios
      .get(`/api/mb/member/get-point`)
      .then((res) => {
        console.log("res: ", res);
        setPoint(res.data.data.point);
      })
      .catch((error) => {});
  };

  const onPayCard = (item) => {
    // TODO active swiper 의 정보 item
    axios
      .post(`/api/app/easy-card/set-rep`, {
        // niceCid: "NABA05226000000000000000007645"
        niceCid: item.niceCid,
      })
      .then((res) => {
        setEpYn(res.data.data.epYn);
        if (res.data.data.easyCardList) {
          console.log(
            "res.data.data.easyCardList: ",
            res.data.data.easyCardList
          );

          let eCard = _.find(res.data.data.easyCardList, (item) => {
            return item.repYn === "Y";
          });
          setEasyCard(eCard);
        }
        // await loadCardList();
      });
  };

  const handleChange = (e) => {
    let checked = e.target.checked;
    if (easyCard) {
      if (checked) {
        // on
        axios.post("api/app/easy-card/pay-on").then(async (res) => {
          await loadCardList();
        });
      } else {
        // off
        axios.post("api/app/easy-card/pay-off").then(async (res) => {
          await loadCardList();
        });
      }
    }
  };

  // const slideChange = (swipe) => {
  //   if (!swipe.isEnd) {
  //     let item = easyCard[swipe.realIndex];
  //     onPayCard(item);
  //   }
  // };

  useEffect(() => {
    if (open === true) {
      refreshBarcode();
      // if (document.getElementById("barcode"))
      //   JsBarcode("#barcode", "99" + no, {
      //     format: "CODE128",
      //     font: "14px NanumSquareRound",
      //     height: 90,
      //     textMargin: 15,
      //     displayValue: false,
      //   });
      if (document.getElementsByTagName("body")[0].classList) {
        document
          .getElementsByTagName("body")[0]
          .classList.toggle("scroll-hidden", true);
      }

      const authToken = cookies.get("X-AUTH-TOKEN") || "";

      if (authToken) {
        loadCardList(); // 앱카드 숨김처리
        loadMyInfo();
        setMyDecodedToken(jwt_decode(authToken));
      } else {
        setMyDecodedToken("");
      }
      setBottomColor("FFFFFF");
    } else {
      setBottomColor("F1270B");
      if (document.getElementsByTagName("body")[0].classList)
        document
          .getElementsByTagName("body")[0]
          .classList.toggle("scroll-hidden", false);
    }
  }, [open]);

  useEffect(() => {
    refreshBarcode();
  }, [epYn]);

  const refreshBarcode = () => {
    clearTimeout(timer);
    setTimeLimit(false);

    if (epYn == "Y") {
      let time = moment().format("HHmmMMDD");
      setBarcodeNo(checkDigit("99" + cookies.get("no") + time));
    } else {
      setBarcodeNo("99" + cookies.get("no"));
    }

    setTimer(
      setTimeout(() => {
        setTimeLimit(true);
      }, [1800000]) //30분
    );
  };

  const checkDigit = (beforeBarcode) => {
    var nDigit = 0;

    for (var i = 0; i < beforeBarcode.length; i++) {
      if (i % 2 == 0) {
        //0,2,4,6  ..

        nDigit += Number(beforeBarcode[i]) * 3;
      } else {
        //1,3,5,7..

        nDigit += Number(beforeBarcode[i]) * 1;
      }
    }

    return beforeBarcode + String((10 - (Number(nDigit) % 10)) % 10);
  };

  return (
    <Sheet
      anchor="bottom"
      isOpen={open}
      onClose={handleDrawerClose}
      className={classes.appCard + " AppCard drawer-common-bottom size-high"}
    >
      <Sheet.Container
        style={{
          background: "transparent",
          boxShadow: "none",
          height: "calc(100vh - 14px)",
        }}
      >
        <Sheet.Header />
        <Sheet.Content>
          <div className="drawer-head">
            <IconButton
              aria-label="close"
              className="btn-close"
              onClick={handleDrawerClose}
            >
              <span className="hidden">닫기</span>
            </IconButton>
          </div>
          <div className="drawer-body">
            {/* <div className="box-type-1 align-c">
          <p className="text">
            <strong>{text}</strong>
          </p>
          <Box component="span" className="count" mt={3}>
            <div
              dangerouslySetInnerHTML={{
                __html: subText,
              }}
            />
            <div className="btm">{btmText}</div>
          </Box>
        </div> */}
            <div className="point-section">
              <h2 className="h2">{myDecodedToken.nm}님의 현재 보유 포인트</h2>
              <Button
                className="cnt"
                onClick={() => {
                  history.push("/point");
                }}
              >
                {point.toLocaleString()}P
              </Button>
              <div className="barcode">
                {timeLimit && (
                  <div className="cover">
                    <Button
                      onClick={() => {
                        refreshBarcode();
                      }}
                    >
                      <RefreshIcon />
                      유효시간이 초과하여 새로고침 해주세요.
                    </Button>
                  </div>
                )}
                {open && (
                  <ReactBarcode
                    value={barcodeNo}
                    options={{
                      format: "code128",
                      font: "14px NanumSquareRound",
                      height: epYn == "Y" ? 112 : 90,
                      textMargin: 15,
                      displayValue: false,
                    }}
                    renderer="svg"
                  />
                )}
                {/* <svg id="barcode" /> */}
                <span className="barcode-number">{noSplit(no)}</span>
              </div>
            </div>
            {/* ~~~~~~~~~~~~~~~~~ card ~~~~~~~~~~~~~~~~~~~ */}
            <div className="card-section">
              <Box display="flex" justifyContent="space-between" pl={8} pr={8}>
                <h2 className="h2">간편결제</h2>
                <Switch
                  {...label}
                  size="medium"
                  checked={epYn == "Y"}
                  onChange={handleChange}
                />
              </Box>
              {!easyCard ? (
                <div className="card-list">
                  <div className="card-item">
                    <div className="card card-big">
                      <Button
                        className="plus-btn"
                        onClick={() => {
                          history.push("/mypage/shopping/pay");
                        }}
                      >
                        <img
                          src={`${
                            process.env.PUBLIC_URL
                          }/images/icon/icon-plus.svg`}
                        />
                        카드 등록
                      </Button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="card-list">
                  <div className="card-item">
                    {epYn == "Y" ? (
                      <div
                        className="card card-big"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL
                          }/images/card-img/card_add_${cardImg(
                            easyCard.cardCompCode
                          )}.png)`,
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "100%",
                        }}
                      >
                        <div className="no">
                          **** **** **** {easyCard.lastNum}
                        </div>
                        <div className="exp">
                          <p>EXP **/**</p>
                          <p>{getCardName(easyCard.cardCompCode)}</p>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="card card-big"
                        style={{
                          backgroundImage: `url(${
                            process.env.PUBLIC_URL
                          }/images/icon/card-easy-pay-off.svg)`,
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "100%",
                          border: "none",
                        }}
                      />
                    )}
                  </div>
                </div>

                //   <Swiper
                //   className="mySwiper card-list"
                //   slidesPerView={"auto"}
                //   centeredSlides={true}
                //   spaceBetween={25}
                //   onSlideChange={slideChange}
                // >
                //   {easyCard.map((item, i) => (
                //     <SwiperSlide key={`card-${i}`}>
                //       <div className="card-item">
                //         <div
                //           className="card"
                //           style={{
                //             backgroundImage: `url(${
                //               process.env.PUBLIC_URL
                //             }/images/card-img/card_add_${cardImg(
                //               item.cardCompCode
                //             )}.png)`,
                //             backgroundRepeat: "no-repeat",
                //             backgroundSize: "100%",
                //           }}
                //         >
                //           <div className="no">
                //             **** **** **** {item.lastNum}
                //           </div>
                //           <div className="exp">
                //             <p>EXP **/**</p>
                //             <p>{getCardName(item.cardCompCode)}</p>
                //           </div>
                //         </div>
                //       </div>
                //     </SwiperSlide>
                //   ))}
                // <SwiperSlide>
                //     <div className="card-list">
                //       <div className="card-item">
                //         <div className="card card-big">
                //           <Button
                //             className="plus-btn"
                //             onClick={() => {
                //               history.push("/mypage/shopping/pay");
                //             }}
                //           >
                //             <img
                //               src={`${
                //                 process.env.PUBLIC_URL
                //               }/images/icon/icon-plus.svg`}
                //             />
                //             카드 등록
                //           </Button>
                //         </div>
                //       </div>
                //     </div>
                //   </SwiperSlide>
                // </Swiper>
              )}

              <ul className="list list-dot color-info font-14">
                {/* <li>화면을 슬라이드하여 결제카드를 변경하실 수 있습니다.</li> */}
                <li>
                  간편결제 OFF일 경우 포인트 사용/적립은 가능하며, 카드 결제는
                  불가능합니다.
                </li>
              </ul>
            </div>
            {/* 앱카드 숨김처리 */}
          </div>
        </Sheet.Content>
      </Sheet.Container>

      <Sheet.Backdrop onClick={handleDrawerClose} />
    </Sheet>
  );

  // 앱카드 숨김처리
  // <div className="card-section">
  //             <Box display="flex" justifyContent="space-between" pl={8} pr={8}>
  //               <h2 className="h2">간편결제</h2>

  //               <Switch
  //                 {...label}
  //                 size="medium"
  //                 checked={epYn == "Y"}
  //                 onChange={handleChange}
  //               />
  //             </Box>
  //             {easyCard && easyCard.length == 0 ? (
  //               <div className="card-list">
  //                 <div className="card-item">
  //                   <div className="card card-big">
  //                     <Button
  //                       className="plus-btn"
  //                       onClick={() => {
  //                         history.push("/mypage/shopping/pay");
  //                       }}
  //                     >
  //                       <img
  //                         src={`${
  //                           process.env.PUBLIC_URL
  //                         }/images/icon/icon-plus.svg`}
  //                       />
  //                       카드 등록
  //                     </Button>
  //                   </div>
  //                 </div>
  //               </div>
  //             ) : (
  //               <Swiper
  //                 className="mySwiper card-list"
  //                 slidesPerView={"auto"}
  //                 centeredSlides={true}
  //                 spaceBetween={25}
  //                 onSlideChange={slideChange}
  //               >
  //                 {easyCard.map((item, i) => (
  //                   <SwiperSlide key={`card-${i}`}>
  //                     <div className="card-item">
  //                       <div
  //                         className="card"
  //                         style={{
  //                           backgroundImage: `url(${
  //                             process.env.PUBLIC_URL
  //                           }/images/card-img/card_add_${cardImg(
  //                             item.cardCompCode
  //                           )}.png)`,
  //                           backgroundRepeat: "no-repeat",
  //                           backgroundSize: "100%",
  //                         }}
  //                       >
  //                         <div className="no">
  //                           **** **** **** {item.lastNum}
  //                         </div>
  //                         <div className="exp">
  //                           <p>EXP **/**</p>
  //                           <p>{getCardName(item.cardCompCode)}</p>
  //                         </div>
  //                       </div>
  //                     </div>
  //                   </SwiperSlide>
  //                 ))}
  //                 <SwiperSlide>
  //                   <div className="card-list">
  //                     <div className="card-item">
  //                       <div className="card card-big">
  //                         <Button
  //                           className="plus-btn"
  //                           onClick={() => {
  //                             history.push("/mypage/shopping/pay");
  //                           }}
  //                         >
  //                           <img
  //                             src={`${
  //                               process.env.PUBLIC_URL
  //                             }/images/icon/icon-plus.svg`}
  //                           />
  //                           카드 등록
  //                         </Button>
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </SwiperSlide>
  //               </Swiper>
  //             )}

  //             <ul className="list list-dot color-info font-14">
  //               <li>화면을 슬라이드하여 결제카드를 변경하실 수 있습니다.</li>
  //               <li>
  //                 다른 수단으로 결제를 원하시는 경우 옵션을 OFF로 변경해주세요.
  //               </li>
  //             </ul>
  //           </div>
}
